var _rect, _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLoginGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 57,
    viewBox: "0 0 56 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.755859,
    width: 55,
    height: 55,
    rx: 27.5,
    fill: "white",
    stroke: "#C7D6EA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0916 28.2511C22.0925 27.6206 22.1938 26.9943 22.3917 26.3957L19.0266 23.8174C18.3518 25.1972 18.001 26.7128 18.001 28.2488C18.001 29.7848 18.3518 31.3004 19.0266 32.6802L22.3917 30.1019C22.1938 29.5048 22.0925 28.88 22.0916 28.2511Z",
    fill: "#FBBC05"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0029 22.3393C29.3466 22.3377 30.6489 22.8039 31.6863 23.658L34.5966 20.7477C33.4447 19.7347 32.0752 19.0001 30.5941 18.6008C29.113 18.2014 27.56 18.1481 26.0549 18.4448C24.5499 18.7415 23.1333 19.3803 21.9145 20.3118C20.6958 21.2434 19.7076 22.4427 19.0264 23.8172L22.3914 26.3955C22.7815 25.2153 23.5338 24.1881 24.5412 23.4599C25.5486 22.7317 26.7599 22.3396 28.0029 22.3393Z",
    fill: "#EA4335"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0029 34.1627C26.7599 34.1624 25.5486 33.7703 24.5412 33.0421C23.5338 32.3139 22.7815 31.2867 22.3914 30.1064L19.0264 32.6848C19.8508 34.3608 21.1294 35.7715 22.7164 36.7564C24.3034 37.7413 26.1351 38.2606 28.0029 38.2553C30.4121 38.279 32.7406 37.3885 34.5193 35.7634L31.3361 33.2896C30.33 33.8901 29.1742 34.1928 28.0029 34.1627Z",
    fill: "#34A853"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3865 30.1021L19.0215 32.6804L22.3865 30.1021Z",
    fill: "#34A853"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.001 26.4312V30.2964H33.3669C33.2515 30.9091 33.0106 31.4913 32.6592 32.0062C32.3078 32.5212 31.8536 32.9578 31.3251 33.2886L34.5083 35.7624C36.3545 34.0526 37.5505 31.5106 37.5505 28.2501C37.5421 27.6373 37.4658 27.0272 37.3231 26.4312H28.001Z",
    fill: "#4285F4"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginGoogle);
export default __webpack_public_path__ + "static/media/login_google.d2818111517adfa118434c584d34f0a9.svg";
export { ForwardRef as ReactComponent };